import { merge } from 'lodash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import type { Observable } from 'rxjs';
import { from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { request as apiRequest } from '@swf/core/api/request';
import { select } from '@swf/core/store';

import type { BoundRequestOptions, ResponseMessage } from '../types/Request';

import useUnmount from './useUnmount';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ObservableRequest = <T = any>(
  options: BoundRequestOptions
) => Observable<ResponseMessage<T>>;

const useRequest = () => {
  const requestOptions = useSelector(select.cms.getRequestOptions);
  const unmount = useUnmount();

  return useCallback<ObservableRequest>(
    (options) => from(apiRequest(merge({}, requestOptions, options))).pipe(takeUntil(unmount)),
    [requestOptions, unmount]
  );
};

export default useRequest;
